import { SearchInput } from "./SearchInput";
import { ZipCodeInput } from "./ZipCodeInput";
import { DanceStyleCheckboxes } from "./DanceStyleCheckboxes";
import { FavoritesToggle } from "./FavoritesToggle";
import { DateRangeFilter } from "./DateRangeFilter";
import type { GeocodingResult } from "@/lib/geocoding";

interface FilterSidebarProps {
  // Search
  searchQuery: string;
  onSearchChange: (query: string) => void;
  // Date Range
  startDate: string;
  endDate: string;
  onStartDateChange: (date: string) => void;
  onEndDateChange: (date: string) => void;
  // Location
  zipCode: string;
  onZipCodeChange: (zipCode: string) => void;
  distance: number;
  onDistanceChange: (distance: number) => void;
  location: GeocodingResult | null;
  onLocationChange: (location: GeocodingResult | null) => void;
  // Dance Styles
  selectedStyles: string[];
  onStyleChange: (styles: string[]) => void;
  // Favorites
  showFavoritesOnly: boolean;
  onFavoritesChange: (show: boolean) => void;
}

export function FilterSidebar({
  searchQuery,
  onSearchChange,
  startDate,
  endDate,
  onStartDateChange,
  onEndDateChange,
  zipCode,
  onZipCodeChange,
  distance,
  onDistanceChange,
  location,
  onLocationChange,
  selectedStyles,
  onStyleChange,
  showFavoritesOnly,
  onFavoritesChange,
}: FilterSidebarProps) {
  return (
    <div className="space-y-6">
      {/* Search */}
      <div className="space-y-3">
        <h3 className="text-sm font-semibold text-foreground">Search</h3>
        <SearchInput value={searchQuery} onChange={onSearchChange} />
      </div>

      {/* Date Range */}
      <DateRangeFilter
        startDate={startDate}
        endDate={endDate}
        onStartDateChange={onStartDateChange}
        onEndDateChange={onEndDateChange}
      />

      {/* Divider */}
      <div className="border-t border-border" />

      {/* Location */}
      <ZipCodeInput
        zipCode={zipCode}
        onZipCodeChange={onZipCodeChange}
        distance={distance}
        onDistanceChange={onDistanceChange}
        location={location}
        onLocationChange={onLocationChange}
      />

      {/* Divider */}
      <div className="border-t border-border" />

      {/* Dance Styles */}
      <DanceStyleCheckboxes
        selectedStyles={selectedStyles}
        onStyleChange={onStyleChange}
      />

      {/* Divider */}
      <div className="border-t border-border" />

      {/* Favorites */}
      <FavoritesToggle
        checked={showFavoritesOnly}
        onCheckedChange={onFavoritesChange}
      />
    </div>
  );
}
